import clone from 'lodash/clone';
import { type OpenApiSchemaCategory } from '../../api/schema';

type PickedCategoryModel = Pick<OpenApiSchemaCategory, 'id' | 'parent_id' | 'title'>;

export type CategoryWithLevelModel<M extends PickedCategoryModel> = M & { level?: number };

/*
 * Возвращает массив категорий, обогащенный признаком 'level', который представляет из себя число,
 * равное уровню вложенности категории
 */
export const setCategoriesLevel = <M extends PickedCategoryModel>(categories: M[]): CategoryWithLevelModel<M>[] => {
    const categoryMap = new Map();

    // Инициализация Map с категориями по их id для быстрого доступа
    categories.forEach((category) => {
        categoryMap.set(category.id, category);
    });

    // Функция для вычисления уровня вложенности категории
    function calculateLevel(category: CategoryWithLevelModel<M>) {
        if (!category.parent_id) {
            return 0; // если нет родительской категории, уровень 0
        }

        const parentCategory = clone(categoryMap.get(category.parent_id));

        if (!parentCategory) {
            return 0; // на случай, если родительской категории не существует в списке
        }

        if (parentCategory.level === undefined) {
            parentCategory.level = calculateLevel(parentCategory); // рекурсивно определяем уровень родителя
        }

        return parentCategory.level + 1; // уровень категории на 1 больше уровня родителя
    }

    // Присваивание уровня вложенности каждой категории
    return categories.map((category) => {
        return {
            ...category,
            level: calculateLevel(category),
        };
    });
};
